// Copy for continuing a tasting: the list of unfinished tastings, "continue editing" on a saved note
// and the opt-in to keep unfinished tastings for other devices (encrypted, off by default). One entry
// per locale; every key exists in all seven (nl is the source, the rest are translations). Our own
// words, as everywhere in the app.
export const continueCopy = {
  nl: {
    "continue.list.title": "Nog niet af",
    "continue.list.resume": "Verder",
    "continue.list.discard": "Weggooien",
    "continue.discard.title": "{title} weggooien?",
    "continue.discard.body":
      "Je notities voor deze proeverij gaan van dit toestel. Dit kan niet ongedaan worden gemaakt.",
    "continue.list.end": "Beëindigen",
    "continue.list.leave": "Verlaten",
    "continue.end.title": "{title} beëindigen?",
    "continue.end.body":
      "De proeverij stopt voor iedereen die meedoet. Dit kan niet ongedaan worden gemaakt.",
    "continue.leave.title": "{title} verlaten?",
    "continue.leave.body":
      "Je gaat uit deze proeverij en de rest proeft gewoon door. Alleen de host kan je opnieuw uitnodigen.",
    "continue.discard.shared.body":
      "Je notities gaan van dit toestel en je stapt uit de gezamenlijke proeverij. Ben je de host, dan stopt die voor iedereen. Dit kan niet ongedaan worden gemaakt.",
    "tasting.flow.person.left": "weggegaan",
    "tasting.flow.lobby.left": "{names} weggegaan",
    "continue.row.wine": "Wijn {n} van {total}",
    "continue.row.shared": "samen",
    "continue.row.solo": "alleen",
    "continue.row.started": "gestart {when}",
    "continue.row.waiting": "wacht op verbinding",
    "continue.row.otherDevice": "van je andere toestel",
    "continue.list.conflict":
      "Je ging verder met {title} op een ander toestel. Dit toestel laat nu die nieuwere versie zien.",
    "continue.note.edit": "Verder bewerken",
    "continue.sync.title": "Proeverijen op je andere toestellen",
    "continue.sync.switch":
      "Bewaar onafgemaakte proeverijen om op een ander toestel verder te gaan",
    "continue.sync.hint":
      "Staat standaard uit: dan verlaat er niets dit toestel. Aan: je onafgemaakte proeverijen worden versleuteld op onze server bewaard, hooguit {days} dagen na je laatste wijziging, en verdwijnen zodra je klaar bent of dit uitzet.",
    "continue.sync.error": "De schakelaar bleef staan zoals hij was.",
    "privacy.consent.drafts":
      "Je keuze wordt met de datum vastgelegd. Zet je dit uit, dan trek je je toestemming in en verwijderen we alle bewaarde proeverijen.",
    "privacy.notice.drafts.title": "Onafgemaakte proeverijen",
    "privacy.notice.drafts.body":
      "Alleen als je dit zelf aanzet in de instellingen, bewaren we je onafgemaakte proeverijen versleuteld, zodat je op een ander toestel verder kunt. Dat geldt ook voor wat je al hebt ingevuld. Ze verdwijnen {drafts} dagen na je laatste wijziging, zodra je klaar bent, als je het uitzet en als je je gegevens of account verwijdert, en staan in je export. Wie de serversleutel beheert kan ze lezen; we gebruiken ze nergens anders voor.",
  },
  en: {
    "continue.list.title": "Not finished yet",
    "continue.list.resume": "Continue",
    "continue.list.discard": "Discard",
    "continue.discard.title": "Discard {title}?",
    "continue.discard.body":
      "Your notes for this tasting go from this device. This cannot be undone.",
    "continue.list.end": "End",
    "continue.list.leave": "Leave",
    "continue.end.title": "End {title}?",
    "continue.end.body": "The tasting stops for everyone who is in it. This cannot be undone.",
    "continue.leave.title": "Leave {title}?",
    "continue.leave.body":
      "You step out of this tasting and the others carry on. Only the host can invite you back.",
    "continue.discard.shared.body":
      "Your notes go from this device and you step out of the shared tasting. If you are the host, it stops for everyone. This cannot be undone.",
    "tasting.flow.person.left": "left",
    "tasting.flow.lobby.left": "{names} left",
    "continue.row.wine": "Wine {n} of {total}",
    "continue.row.shared": "together",
    "continue.row.solo": "solo",
    "continue.row.started": "started {when}",
    "continue.row.waiting": "waiting for a connection",
    "continue.row.otherDevice": "from your other device",
    "continue.list.conflict":
      "You carried on with {title} on another device. This device now shows that newer version.",
    "continue.note.edit": "Continue editing",
    "continue.sync.title": "Tastings on your other devices",
    "continue.sync.switch": "Keep unfinished tastings to continue on another device",
    "continue.sync.hint":
      "Off by default: nothing leaves this device. On: your unfinished tastings are kept on our server, encrypted, for at most {days} days after your last change, and are removed once you finish or turn this off.",
    "continue.sync.error": "The switch stayed as it was.",
    "privacy.consent.drafts":
      "Your choice is recorded with the date. Turning this off withdraws your consent and removes every kept tasting.",
    "privacy.notice.drafts.title": "Unfinished tastings",
    "privacy.notice.drafts.body":
      "Only if you turn it on yourself in the settings do we keep your unfinished tastings, encrypted, so you can continue on another device. That includes what you already filled in. They go {drafts} days after your last change, when you finish, when you turn it off and when you delete your data or account, and they are in your export. Whoever holds the server key can read them; we use them for nothing else.",
  },
  de: {
    "continue.list.title": "Noch nicht fertig",
    "continue.list.resume": "Weiter",
    "continue.list.discard": "Verwerfen",
    "continue.discard.title": "{title} verwerfen?",
    "continue.discard.body":
      "Deine Notizen zu dieser Verkostung verschwinden von diesem Gerät. Das lässt sich nicht rückgängig machen.",
    "continue.list.end": "Beenden",
    "continue.list.leave": "Verlassen",
    "continue.end.title": "{title} beenden?",
    "continue.end.body":
      "Die Verkostung endet für alle, die dabei sind. Das lässt sich nicht rückgängig machen.",
    "continue.leave.title": "{title} verlassen?",
    "continue.leave.body":
      "Du steigst aus dieser Verkostung aus, die anderen machen weiter. Nur der Gastgeber kann dich wieder einladen.",
    "continue.discard.shared.body":
      "Deine Notizen verschwinden von diesem Gerät und du verlässt die gemeinsame Verkostung. Bist du der Gastgeber, endet sie für alle. Das lässt sich nicht rückgängig machen.",
    "tasting.flow.person.left": "gegangen",
    "tasting.flow.lobby.left": "{names} gegangen",
    "continue.row.wine": "Wein {n} von {total}",
    "continue.row.shared": "gemeinsam",
    "continue.row.solo": "allein",
    "continue.row.started": "gestartet {when}",
    "continue.row.waiting": "wartet auf Verbindung",
    "continue.row.otherDevice": "von deinem anderen Gerät",
    "continue.list.conflict":
      "Du hast {title} auf einem anderen Gerät fortgesetzt. Dieses Gerät zeigt jetzt die neuere Version.",
    "continue.note.edit": "Weiter bearbeiten",
    "continue.sync.title": "Verkostungen auf deinen anderen Geräten",
    "continue.sync.switch":
      "Unfertige Verkostungen aufbewahren, um auf einem anderen Gerät weiterzumachen",
    "continue.sync.hint":
      "Standardmäßig aus: Dann verlässt nichts dieses Gerät. An: Deine unfertigen Verkostungen werden verschlüsselt auf unserem Server gespeichert, höchstens {days} Tage nach deiner letzten Änderung, und verschwinden, sobald du fertig bist oder das ausschaltest.",
    "continue.sync.error": "Der Schalter blieb, wie er war.",
    "privacy.consent.drafts":
      "Deine Wahl wird mit Datum festgehalten. Schaltest du das aus, ziehst du deine Einwilligung zurück und wir löschen alle gespeicherten Verkostungen.",
    "privacy.notice.drafts.title": "Unfertige Verkostungen",
    "privacy.notice.drafts.body":
      "Nur wenn du es selbst in den Einstellungen einschaltest, speichern wir deine unfertigen Verkostungen verschlüsselt, damit du auf einem anderen Gerät weitermachen kannst. Das umfasst auch, was du schon ausgefüllt hast. Sie verschwinden {drafts} Tage nach deiner letzten Änderung, wenn du fertig bist, wenn du es ausschaltest und wenn du deine Daten oder dein Konto löschst; sie stehen in deinem Export. Wer den Serverschlüssel verwaltet, kann sie lesen; wir nutzen sie für nichts anderes.",
  },
  fr: {
    "continue.list.title": "Pas encore terminé",
    "continue.list.resume": "Continuer",
    "continue.list.discard": "Abandonner",
    "continue.discard.title": "Abandonner {title} ?",
    "continue.discard.body":
      "Tes notes pour cette dégustation disparaissent de cet appareil. C'est irréversible.",
    "continue.list.end": "Terminer",
    "continue.list.leave": "Quitter",
    "continue.end.title": "Terminer {title} ?",
    "continue.end.body":
      "La dégustation s'arrête pour tous ceux qui y participent. C'est irréversible.",
    "continue.leave.title": "Quitter {title} ?",
    "continue.leave.body":
      "Tu sors de cette dégustation et les autres continuent. Seul l'hôte peut t'inviter à nouveau.",
    "continue.discard.shared.body":
      "Tes notes disparaissent de cet appareil et tu quittes la dégustation à plusieurs. Si tu es l'hôte, elle s'arrête pour tout le monde. C'est irréversible.",
    "tasting.flow.person.left": "parti",
    "tasting.flow.lobby.left": "{names} parti",
    "continue.row.wine": "Vin {n} sur {total}",
    "continue.row.shared": "à plusieurs",
    "continue.row.solo": "en solo",
    "continue.row.started": "commencée {when}",
    "continue.row.waiting": "attend une connexion",
    "continue.row.otherDevice": "de ton autre appareil",
    "continue.list.conflict":
      "Tu as poursuivi {title} sur un autre appareil. Cet appareil affiche maintenant la version plus récente.",
    "continue.note.edit": "Continuer la modification",
    "continue.sync.title": "Dégustations sur tes autres appareils",
    "continue.sync.switch":
      "Garder les dégustations inachevées pour continuer sur un autre appareil",
    "continue.sync.hint":
      "Désactivé par défaut : rien ne quitte cet appareil. Activé : tes dégustations inachevées sont gardées chiffrées sur notre serveur, au plus {days} jours après ta dernière modification, et disparaissent dès que tu as fini ou que tu désactives cette option.",
    "continue.sync.error": "L'interrupteur est resté comme il était.",
    "privacy.consent.drafts":
      "Ton choix est enregistré avec la date. Le désactiver retire ton consentement et supprime toutes les dégustations gardées.",
    "privacy.notice.drafts.title": "Dégustations inachevées",
    "privacy.notice.drafts.body":
      "Seulement si tu l'actives toi-même dans les réglages, nous gardons tes dégustations inachevées, chiffrées, pour que tu puisses continuer sur un autre appareil, y compris ce que tu as déjà rempli. Elles disparaissent {drafts} jours après ta dernière modification, quand tu as fini, quand tu désactives l'option et quand tu supprimes tes données ou ton compte, et figurent dans ton export. Celui qui gère la clé du serveur peut les lire ; nous ne les utilisons pour rien d'autre.",
  },
  es: {
    "continue.list.title": "Aún sin terminar",
    "continue.list.resume": "Continuar",
    "continue.list.discard": "Descartar",
    "continue.discard.title": "¿Descartar {title}?",
    "continue.discard.body":
      "Tus notas de esta cata desaparecen de este dispositivo. No se puede deshacer.",
    "continue.list.end": "Terminar",
    "continue.list.leave": "Salir",
    "continue.end.title": "¿Terminar {title}?",
    "continue.end.body":
      "La cata se detiene para todos los que están en ella. No se puede deshacer.",
    "continue.leave.title": "¿Salir de {title}?",
    "continue.leave.body":
      "Sales de esta cata y los demás siguen. Solo el anfitrión puede volver a invitarte.",
    "continue.discard.shared.body":
      "Tus notas desaparecen de este dispositivo y sales de la cata en grupo. Si eres el anfitrión, se detiene para todos. No se puede deshacer.",
    "tasting.flow.person.left": "se fue",
    "tasting.flow.lobby.left": "{names} se fue",
    "continue.row.wine": "Vino {n} de {total}",
    "continue.row.shared": "en grupo",
    "continue.row.solo": "en solitario",
    "continue.row.started": "empezada {when}",
    "continue.row.waiting": "esperando conexión",
    "continue.row.otherDevice": "de tu otro dispositivo",
    "continue.list.conflict":
      "Seguiste con {title} en otro dispositivo. Este dispositivo muestra ahora esa versión más reciente.",
    "continue.note.edit": "Seguir editando",
    "continue.sync.title": "Catas en tus otros dispositivos",
    "continue.sync.switch": "Guardar las catas sin terminar para continuar en otro dispositivo",
    "continue.sync.hint":
      "Desactivado por defecto: nada sale de este dispositivo. Activado: tus catas sin terminar se guardan cifradas en nuestro servidor, como máximo {days} días tras tu último cambio, y desaparecen cuando terminas o lo desactivas.",
    "continue.sync.error": "El interruptor se quedó como estaba.",
    "privacy.consent.drafts":
      "Tu elección se registra con la fecha. Si lo desactivas, retiras tu consentimiento y borramos todas las catas guardadas.",
    "privacy.notice.drafts.title": "Catas sin terminar",
    "privacy.notice.drafts.body":
      "Solo si lo activas tú en los ajustes guardamos tus catas sin terminar, cifradas, para que puedas continuar en otro dispositivo, incluido lo que ya rellenaste. Desaparecen {drafts} días después de tu último cambio, cuando terminas, cuando lo desactivas y cuando borras tus datos o tu cuenta, y aparecen en tu exportación. Quien gestiona la clave del servidor puede leerlas; no las usamos para nada más.",
  },
  it: {
    "continue.list.title": "Non ancora finito",
    "continue.list.resume": "Continua",
    "continue.list.discard": "Scarta",
    "continue.discard.title": "Scartare {title}?",
    "continue.discard.body":
      "Le tue note per questa degustazione spariscono da questo dispositivo. Non si può annullare.",
    "continue.list.end": "Termina",
    "continue.list.leave": "Esci",
    "continue.end.title": "Terminare {title}?",
    "continue.end.body":
      "La degustazione si ferma per tutti quelli che ci sono. Non si può annullare.",
    "continue.leave.title": "Uscire da {title}?",
    "continue.leave.body":
      "Esci da questa degustazione e gli altri proseguono. Solo l'host può invitarti di nuovo.",
    "continue.discard.shared.body":
      "Le tue note spariscono da questo dispositivo ed esci dalla degustazione in compagnia. Se sei l'host, si ferma per tutti. Non si può annullare.",
    "tasting.flow.person.left": "andato via",
    "tasting.flow.lobby.left": "{names} andato via",
    "continue.row.wine": "Vino {n} di {total}",
    "continue.row.shared": "in compagnia",
    "continue.row.solo": "da solo",
    "continue.row.started": "iniziata {when}",
    "continue.row.waiting": "in attesa di connessione",
    "continue.row.otherDevice": "dal tuo altro dispositivo",
    "continue.list.conflict":
      "Hai proseguito {title} su un altro dispositivo. Questo dispositivo mostra ora quella versione più recente.",
    "continue.note.edit": "Continua a modificare",
    "continue.sync.title": "Degustazioni sugli altri tuoi dispositivi",
    "continue.sync.switch":
      "Conserva le degustazioni non finite per continuare su un altro dispositivo",
    "continue.sync.hint":
      "Disattivato per impostazione predefinita: nulla lascia questo dispositivo. Attivo: le tue degustazioni non finite sono conservate cifrate sul nostro server, al massimo {days} giorni dopo l'ultima modifica, e spariscono appena finisci o disattivi.",
    "continue.sync.error": "L'interruttore è rimasto com'era.",
    "privacy.consent.drafts":
      "La tua scelta viene registrata con la data. Disattivandola ritiri il consenso e cancelliamo tutte le degustazioni conservate.",
    "privacy.notice.drafts.title": "Degustazioni non finite",
    "privacy.notice.drafts.body":
      "Solo se lo attivi tu nelle impostazioni conserviamo le tue degustazioni non finite, cifrate, così puoi continuare su un altro dispositivo, compreso ciò che hai già compilato. Spariscono {drafts} giorni dopo l'ultima modifica, quando finisci, quando disattivi l'opzione e quando elimini i tuoi dati o l'account, e compaiono nella tua esportazione. Chi gestisce la chiave del server può leggerle; non le usiamo per nient'altro.",
  },
  pt: {
    "continue.list.title": "Ainda por acabar",
    "continue.list.resume": "Continuar",
    "continue.list.discard": "Descartar",
    "continue.discard.title": "Descartar {title}?",
    "continue.discard.body":
      "As tuas notas desta prova desaparecem deste dispositivo. Não se pode desfazer.",
    "continue.list.end": "Terminar",
    "continue.list.leave": "Sair",
    "continue.end.title": "Terminar {title}?",
    "continue.end.body": "A prova termina para todos os que estão nela. Não se pode desfazer.",
    "continue.leave.title": "Sair de {title}?",
    "continue.leave.body":
      "Sais desta prova e os outros continuam. Só o anfitrião te pode convidar de novo.",
    "continue.discard.shared.body":
      "As tuas notas desaparecem deste dispositivo e sais da prova em grupo. Se és o anfitrião, termina para todos. Não se pode desfazer.",
    "tasting.flow.person.left": "saiu",
    "tasting.flow.lobby.left": "{names} saiu",
    "continue.row.wine": "Vinho {n} de {total}",
    "continue.row.shared": "em grupo",
    "continue.row.solo": "a solo",
    "continue.row.started": "começada {when}",
    "continue.row.waiting": "à espera de ligação",
    "continue.row.otherDevice": "do teu outro dispositivo",
    "continue.list.conflict":
      "Continuaste {title} noutro dispositivo. Este dispositivo mostra agora essa versão mais recente.",
    "continue.note.edit": "Continuar a editar",
    "continue.sync.title": "Provas nos teus outros dispositivos",
    "continue.sync.switch": "Guardar as provas por acabar para continuar noutro dispositivo",
    "continue.sync.hint":
      "Desligado por predefinição: nada sai deste dispositivo. Ligado: as tuas provas por acabar ficam guardadas cifradas no nosso servidor, no máximo {days} dias após a tua última alteração, e desaparecem quando acabares ou desligares.",
    "continue.sync.error": "O interruptor ficou como estava.",
    "privacy.consent.drafts":
      "A tua escolha fica registada com a data. Ao desligar, retiras o consentimento e apagamos todas as provas guardadas.",
    "privacy.notice.drafts.title": "Provas por acabar",
    "privacy.notice.drafts.body":
      "Só se o ligares tu nas definições guardamos as tuas provas por acabar, cifradas, para poderes continuar noutro dispositivo, incluindo o que já preencheste. Desaparecem {drafts} dias após a tua última alteração, quando acabares, quando desligares e quando apagares os teus dados ou a conta, e constam da tua exportação. Quem gere a chave do servidor pode lê-las; não as usamos para mais nada.",
  },
} as const;
